require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-how-to-use-social-channel-for-customer-service.json") })
        }
      }, "path---tapd-in-how-to-use-social-channel-for-customer-service");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-how-to-use-social-channel-for-customer-service!./.cache/json/tapd-in-how-to-use-social-channel-for-customer-service.json
// module id = 851
// module chunks = 231608221292675